import { Component, Input, OnChanges } from '@angular/core';
import { ResultListValueField } from '../../model/result-list-value-field';
import { CalculatorResult } from '../../../../models/analysis/solar-calculator-result';
import { PowerPlant } from '../../model/power-plant';

@Component({
  selector: 'psc-yearly-savings',
  templateUrl: './yearly-savings.component.html',
})
export class YearlySavingsComponent implements OnChanges {

  @Input() powerPlant: PowerPlant | undefined;
  @Input() solarCalculatorResult: CalculatorResult;

  @Input() extendedData: boolean;
  @Input() extendedDataBlurred: boolean;

  yearlySavingsValues: ResultListValueField[];
  yearlySavingsAdvancedValues: ResultListValueField[];

  ngOnChanges() {
    this.setValues();
  }

  private setValues() {

    const currency = this.solarCalculatorResult.currency;

    this.yearlySavingsValues = [
      {
        labelKey: 'consumption-kwh',
        value: this.solarCalculatorResult.annualConsumptionKWh,
        secondValue: this.solarCalculatorResult.annualReductionConsumptionKWh,
        unit: 'kWh',
      },
      {
        labelKey: 'consumption-money',
        value: this.solarCalculatorResult.annualConsumptionMoney,
        secondValue: this.solarCalculatorResult.annualReductionConsumptionMoney,
        unit: currency,
      },
      {
        labelKey: 'peak-power-money',
        value: this.solarCalculatorResult.annualPowerPeakMoney,
        secondValue: this.solarCalculatorResult.annualReductionPowerPeakMoney,
        unit: currency,
      },
      {
        labelKey: 'bill-reduction',
        value: 0,
        secondValue: this.solarCalculatorResult.annualReductionConsumptionPercentage,
        unit: '%',
      },
      {
        labelKey: 'peak-power-percentage-reduction',
        value: 0,
        secondValue: this.solarCalculatorResult.annualReductionPowerPeakPercentage,
        unit: '%',
      },
      {
        labelKey: 'co2-reduction',
        value: 0,
        secondValue: this.solarCalculatorResult.annualCO2Reduction,
        unit: 'kg',
      },
    ];

    if (this.extendedData) {
      this.yearlySavingsAdvancedValues = [
        {
          labelKey: 'annual-production-kwh',
          value: 0,
          secondValue: this.solarCalculatorResult.annualProductionKWh,
          unit: 'kWh',
        },
        {
          labelKey: 'feed-in-kwh',
          value: 0,
          secondValue: this.solarCalculatorResult.annualFeedInEnergyToGridKWh,
          unit: 'kWh',
        },
        {
          labelKey: 'saving-kwh',
          value: 0,
          secondValue: this.solarCalculatorResult.annualSavingEnergyFromPowerPlantKWh,
          unit: 'kWh',
        },
        {
          labelKey: 'annual-bill',
          value: 0,
          secondValue: this.solarCalculatorResult.annualSavingEnergyFromPowerPlantMoney,
          unit: currency,
        },
        {
          labelKey: 'overload-bill',
          value: 0,
          secondValue: this.solarCalculatorResult.annualFeedInEnergyToGridMoney,
          unit: currency,
        },
        {
          labelKey: 'annual-peak-power-saving-money',
          value: 0,
          secondValue: this.solarCalculatorResult.annualPowerPeakSavingMoney,
          unit: currency,
        },
        {
          labelKey: 'overall-savings',
          value: 0,
          secondValue: this.solarCalculatorResult.annualFNEEnergyMoney,
          unit: currency,
        },
        {
          labelKey: 'feed-in-percentage',
          value: 0,
          secondValue: this.solarCalculatorResult.annualFeedInEnergyToGridPercentage,
          unit: '%',
        },
      ];
    }


  }
}
